/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SizeEstimate } from './SizeEstimate';
import {
    SizeEstimateFromJSON,
    SizeEstimateFromJSONTyped,
    SizeEstimateToJSON,
    SizeEstimateToJSONTyped,
} from './SizeEstimate';
import type { EstimateContext } from './EstimateContext';
import {
    EstimateContextFromJSON,
    EstimateContextFromJSONTyped,
    EstimateContextToJSON,
    EstimateContextToJSONTyped,
} from './EstimateContext';
import type { FormulaWeightRecord } from './FormulaWeightRecord';
import {
    FormulaWeightRecordFromJSON,
    FormulaWeightRecordFromJSONTyped,
    FormulaWeightRecordToJSON,
    FormulaWeightRecordToJSONTyped,
} from './FormulaWeightRecord';

/**
 * One provider's entry under prediction.json's `size_estimates` — the
 * corpus shape the eval parses. Persisted via model_dump(exclude_none=True),
 * so a failed record carries only status + error.
 * @export
 * @interface ProviderEstimateRecord
 */
export interface ProviderEstimateRecord {
    /**
     * 
     */
    status: ProviderEstimateRecordStatusEnum;
    /**
     * 
     */
    error?: string | null;
    /**
     * 
     */
    estimate?: SizeEstimate | null;
    /**
     * 
     */
    model?: string | null;
    /**
     * 
     */
    promptVersion?: string | null;
    /**
     * 
     */
    requestId?: string | null;
    /**
     * 
     */
    context?: EstimateContext | null;
    /**
     * 
     */
    raw?: string | null;
    /**
     * 
     */
    formulaWeight?: FormulaWeightRecord | null;
}


/**
 * @export
 */
export const ProviderEstimateRecordStatusEnum = {
    Ok: 'ok',
    Failed: 'failed',
} as const;
export type ProviderEstimateRecordStatusEnum = typeof ProviderEstimateRecordStatusEnum[keyof typeof ProviderEstimateRecordStatusEnum];


/**
 * Check if a given object implements the ProviderEstimateRecord interface.
 */
export function instanceOfProviderEstimateRecord(value: object): value is ProviderEstimateRecord {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ProviderEstimateRecordFromJSON(json: any): ProviderEstimateRecord {
    return ProviderEstimateRecordFromJSONTyped(json, false);
}

export function ProviderEstimateRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderEstimateRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'error': json['error'] === undefined ? undefined : json['error'] === null ? null : json['error'],
        'estimate': json['estimate'] === undefined ? undefined : json['estimate'] === null ? null : SizeEstimateFromJSON(json['estimate']),
        'model': json['model'] === undefined ? undefined : json['model'] === null ? null : json['model'],
        'promptVersion': json['prompt_version'] === undefined ? undefined : json['prompt_version'] === null ? null : json['prompt_version'],
        'requestId': json['request_id'] === undefined ? undefined : json['request_id'] === null ? null : json['request_id'],
        'context': json['context'] === undefined ? undefined : json['context'] === null ? null : EstimateContextFromJSON(json['context']),
        'raw': json['raw'] === undefined ? undefined : json['raw'] === null ? null : json['raw'],
        'formulaWeight': json['formula_weight'] === undefined ? undefined : json['formula_weight'] === null ? null : FormulaWeightRecordFromJSON(json['formula_weight']),
    };
}

export function ProviderEstimateRecordToJSON(json: any): ProviderEstimateRecord {
    return ProviderEstimateRecordToJSONTyped(json, false);
}

export function ProviderEstimateRecordToJSONTyped(value?: ProviderEstimateRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'error': value['error'],
        'estimate': SizeEstimateToJSON(value['estimate']),
        'model': value['model'],
        'prompt_version': value['promptVersion'],
        'request_id': value['requestId'],
        'context': EstimateContextToJSON(value['context']),
        'raw': value['raw'],
        'formula_weight': FormulaWeightRecordToJSON(value['formulaWeight']),
    };
}

